import React, { useState } from 'react';
import Section from './Section';
import { useAccountRows, useQuotedAdd } from './hooks';
import { renewableDomains, renewalTerms, renewalLine, renewalLineId, renewalBlocker } from '../../lib/cartRenewal';
import { select, addBtn, hint, muted, refusal, retryBtn } from './styles';

// Renew a domain the account already holds (src/lib/cartRenewal.js). The line
// is priced by squish-backend when added and goes in the cart as priced.
export default function RenewalSection(props) {
  return (
    <Section title="Renew a domain">
      <RenewalBody {...props} />
    </Section>
  );
}

function RenewalBody({ accountId, isProspect, isInvoice, billingTerms, onAdd }) {
  const terms = renewalTerms(billingTerms);
  const [domains, retry] = useAccountRows({ accountId, enabled: !isProspect && !isInvoice, pick: renewableDomains });
  const [domain, setDomain] = useState('');
  const [termMonths, setTermMonths] = useState(null);
  const { add, busy, error, clearError } = useQuotedAdd({ accountId, prospect: null, onAdd });

  const picked = Array.isArray(domains) ? (domains.includes(domain) ? domain : domains[0]) : '';
  const term = terms.find(t => t.termMonths === termMonths) || terms[0] || null;
  const blocker = renewalBlocker({ isInvoice, isProspect, terms, domains });

  return (
    <>
      {!blocker && (
        <div style={{ display: 'flex', gap: 6 }}>
          <select value={picked} onChange={e => { setDomain(e.target.value); clearError(); }} style={{ ...select, flex: 1, minWidth: 0 }}>
            {domains.map(d => <option key={d} value={d}>{d}</option>)}
          </select>
          <select value={term.termMonths} onChange={e => { setTermMonths(Number(e.target.value)); clearError(); }} style={select}>
            {terms.map(t => <option key={t.termMonths} value={t.termMonths}>{t.label}</option>)}
          </select>
          <button
            onClick={() => add(renewalLine(picked, term.termMonths), renewalLineId(picked))}
            disabled={busy}
            style={{ ...addBtn, opacity: busy ? 0.5 : 1 }}
          >
            {busy ? 'Pricing…' : '+ Add'}
          </button>
        </div>
      )}
      {blocker && (
        <div style={muted}>
          {blocker}
          {domains?.error && <button onClick={retry} style={retryBtn}>Retry</button>}
        </div>
      )}
      {error && <div style={refusal}>⚠ {error}</div>}
      <div style={hint}>Priced at today's renewal rate when added. Adding the same domain again replaces it.</div>
    </>
  );
}
